<!-- components/IconEnterprice.vue -->
<template>
  <div class="icon-wrapper" :style="wrapperStyle">
    <img :src="iconSrc" :alt="alt" class="icon-img">
  </div>
</template>

<script>
export default {
  name: 'IconEnterprice',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: 45
    },
    alt: {
      type: String,
      default: 'Icono'
    },
    bgColor: {
      type: String,
      default: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    padding: {
      type: [String, Number],
      default: 10
    },
    centered: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    border: {
      type: String,
      default: 'none'
    }
  },
  computed: {
    iconSrc() {
      return `${process.env.BASE_URL}img/svg/${this.name}.svg`
    },
    wrapperStyle() {
      const style = {
        width: this.size + 'px',
        height: this.size + 'px',
        padding: this.padding + 'px',
        background: this.bgColor,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
      
      // Border radius condicional
      if (this.rounded) {
        style.borderRadius = '50%'
      } else {
        style.borderRadius = '8px'
      }
      
      // Shadow condicional
      if (this.shadow) {
        style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)'
      }
      
      // Border condicional
      if (this.border !== 'none') {
        style.border = this.border
      }
      
      // 🔥 Centrado automático
      if (this.centered) {
        style.display = 'flex'
        style.margin = '0 auto'
      }
      
      return style
    }
  }
}
</script>

<style scoped>
.icon-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}
</style>